import clsx from "clsx";

import styles from "./NavLanguageSwitcher.module.scss";
import Dropdown from "../support/dropdown/Dropdown";

export const LanguageOptions = [
  {
    label: "English",
    value: "en",
  },
  {
    label: "Svenska",
    value: "sv",
  },
  {
    label: "Norsk",
    value: "nb",
  },
];

export default function NavLanguageSwitcher() {
  const isNonOrderRoute = false;

  return (
    <div
      className={clsx(styles.localeSwitchContainer, {
        [styles.isOrderPage]: !isNonOrderRoute,
      })}
    >
      {!isNonOrderRoute && <div className={styles.divider} />}
      <Dropdown
        label={"EN"}
        buttonClassName={styles.localeSwitchButton}
        popupClassName={styles.localSwitchDropdown}
        labelClassName={styles.localeSwitchLabel}
        popupPlacement="top-end"
        options={LanguageOptions}
      />
    </div>
  );
}
